import type { DrilledHole, DrillHole } from '~api/services';
import { formatDate, formatTooltipFromFields, type TooltipField } from '~utils';

const DRILLED_TOOLTIP_FIELDS: TooltipField<DrilledHole>[] = [
  { label: 'Hole', getValue: (hole) => hole.hole_name },
  { label: 'Depth', getValue: (hole) => hole.depth_actual, format: (value) => `${Number(value).toFixed(2)}m` },
  {
    label: 'Diameter',
    getValue: (hole) => hole.diameter_planned,
    format: (value) => `${(Number(value) * 1000).toFixed(0)}mm`,
  },
  { label: 'Dip', getValue: (hole) => hole.dip_actual, format: (value) => `${Number(value).toFixed(0)}°` },
  { label: 'Bearing', getValue: (hole) => hole.bearing_actual, format: (value) => `${Number(value).toFixed(0)}°` },
  { label: 'Hardness', getValue: (hole) => hole.hardness },
  { label: 'MWD', getValue: (hole) => hole.mwd },
  { label: 'Source', getValue: (hole) => hole.source_name },
];

const NEIGHBOURING_TOOLTIP_FIELDS: TooltipField<DrillHole>[] = [
  { label: 'Hole', getValue: (hole) => hole.hole_name },
  { label: 'Pattern', getValue: (hole) => hole.pattern_name },
  { label: 'Depth', getValue: (hole) => hole.depth, format: (value) => `${Number(value).toFixed(2)}m` },
  { label: 'Diameter', getValue: (hole) => String(hole.diameter) },
  { label: 'Dip', getValue: (hole) => hole.dip, format: (value) => `${Number(value).toFixed(0)}°` },
  { label: 'Bearing', getValue: (hole) => hole.bearing, format: (value) => `${Number(value).toFixed(0)}°` },
  { label: 'Redrill', getValue: (hole) => hole.redrill, format: (value) => (value ? 'Yes' : 'No') },
  { label: 'Source', getValue: (hole) => hole.source },
  { label: 'Updated', getValue: (hole) => formatDate(new Date(hole.datetime_updated)) },
];

const formatDrilledHoleTooltip = (hole: DrilledHole): string => formatTooltipFromFields(hole, DRILLED_TOOLTIP_FIELDS);

const formatNeighbouringDrillHoleTooltip = (hole: DrillHole): string =>
  formatTooltipFromFields(hole, NEIGHBOURING_TOOLTIP_FIELDS);

export { formatDrilledHoleTooltip, formatNeighbouringDrillHoleTooltip };
